import { legalEN } from "./legalEN";
import { legalFR } from "./legalFR";
import { legalIT } from "./legalIT";
import { uiEN, catEN, descEN, docsExtraEN } from "./legalExtraEN";
import { uiFR, catFR, descFR, docsExtraFR } from "./legalExtraFR";
import { uiIT, catIT, descIT, docsExtraIT } from "./legalExtraIT";
import { LEGAL_CATEGORIES, LEGAL_META, LEGAL_ROUTES, FOOTER_LEGAL } from "./legalRegistry";

// Merge the three legacy docs (privacy/terms/mifid) with the new extra docs, attaching
// the short card description to each document object.
const compose = (base, extra, ui, categories, descs) => {
  const docs = {
    privacy: base.privacy,
    terms: base.terms,
    "mifid-ii": base.mifid,
    ...extra,
  };
  Object.keys(docs).forEach((slug) => {
    docs[slug] = { ...docs[slug], desc: descs[slug] };
  });
  return { ui, categories, docs };
};

export const legal = {
  EN: compose(legalEN, docsExtraEN, uiEN, catEN, descEN),
  FR: compose(legalFR, docsExtraFR, uiFR, catFR, descFR),
  IT: compose(legalIT, docsExtraIT, uiIT, catIT, descIT),
};

export { LEGAL_CATEGORIES, LEGAL_META, LEGAL_ROUTES, FOOTER_LEGAL };
